

































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { backgroundImage } from '@/shared/utils/images'
import RespondecoResponsiveImage from '@/shared/components/respondeco-responsive-image.vue'

@Component({
  components: { RespondecoResponsiveImage },
})
export default class RespondecoGalleryItem extends Vue {
  @Prop({
    required: true,
    type: String,
  })
  public readonly image!: string

  public backgroundImage = backgroundImage

  public remove() {
    this.$emit('remove')
  }
}
